import { queryOptions, useMutation } from '@tanstack/react-query'

import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'

import { PERMISSION_LIST_KEY, ROLE_LIST_KEY } from './role.constants'
import {
  createRole,
  getPermissionList,
  getRoleList,
  updateRole,
} from './role.service'
import type {
  TCreateRoleRequest,
  TRole,
  TUpdateRoleRequest,
} from './role.types'

export function roleListQueryOptions() {
  return queryOptions({ queryKey: ROLE_LIST_KEY, queryFn: getRoleList })
}

export function permissionListQueryOptions() {
  return queryOptions({
    queryKey: PERMISSION_LIST_KEY,
    queryFn: getPermissionList,
    staleTime: Infinity,
  })
}

export function useCreateRole({
  onSuccess,
  onError,
}: TMutation<TRole, TResponseError, TCreateRoleRequest>) {
  return useMutation<TRole, TResponseError, TCreateRoleRequest>({
    mutationFn: createRole,
    onSuccess,
    onError,
  })
}

export function useUpdateRole({
  onSuccess,
  onError,
}: TMutation<TRole, TResponseError, { id: string; body: TUpdateRoleRequest }>) {
  return useMutation<
    TRole,
    TResponseError,
    { id: string; body: TUpdateRoleRequest }
  >({
    mutationFn: ({ id, body }) => updateRole(id, body),
    onSuccess,
    onError,
  })
}
